
import { ARROW_AVAILABLE_POSITION } from './Arrow.constants'

export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: ARROW_AVAILABLE_POSITION.LEFT,
    },
  },
  computed: {
    arrowClassNames() {
      const styles = [this.$style[`arrow-${this.position}`]]

      if (this.disabled) {
        styles.push(this.$style['arrow-disabled'])
      } else if (this.checked) {
        styles.push(this.$style['arrow-checked'])
      } else {
        styles.push(this.$style['arrow-default'])
      }

      return styles
    },
  },
}
